module.exports = __webpack_public_path__ + "img/ai_saidao_intro.11fe0427.png";